import { render, staticRenderFns } from "./IssueGoals.vue?vue&type=template&id=7b1fd5ef&scoped=true"
import script from "./IssueGoals.vue?vue&type=script&lang=js"
export * from "./IssueGoals.vue?vue&type=script&lang=js"
import style0 from "./IssueGoals.vue?vue&type=style&index=0&id=7b1fd5ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1fd5ef",
  null
  
)

export default component.exports